export default __webpack_public_path__ + "static/media/Christian_Pinto_Resume.663a4fc4.pdf";